<template>
    <v-card tile>
        <v-card-actions class="shadow">
            <!--
            <v-btn
                    v-if="Boolean(buttonFalseText)"
                    :title="buttonFalseText"
                    :disabled="loading"
                    class="sr-button"
                    text
                    @click.stop="canceled"
            >{{ buttonFalseText }}
            </v-btn>
          -->
            <v-btn
                    v-if="Boolean(buttonTrueText)"
                    :title="buttonTrueText"
                    :loading="loading"
                    :disabled="loading"
                    class="sr-button"
                    text
                    @click.stop="confirmed"
            >{{ buttonTrueText }}
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
  import { VCard, VCardActions, VSpacer, VBtn } from 'vuetify/lib'

  export default {
    components: {
      VCard,
      VCardActions,
      VSpacer,
      VBtn
    },
    props: {
      buttonTrueText: {
        type: String,
        default: 'Ja'
      },
      buttonFalseText: {
        type: String,
        default: 'Nein'
      },
      buttonTrueColor: {
        type: String,
        default: 'primary'
      },
      buttonFalseColor: {
        type: String,
        default: 'grey'
      },
      text: {
        type: Boolean,
        default: false
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {}
    },
    methods: {
      canceled () {
        this.$emit('canceled')
      },
      confirmed () {
        this.$emit('confirmed')
      }
    }
  }
</script>
